import { signInWithEmailAndPassword } from "firebase/auth";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { fAuth, firebaseApp } from "../config/firebase";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useAuthContext } from "../hooks/useAuth";
import useLoaderContext from "../hooks/useLoading";
import { getFunctions } from "firebase/functions";
import { useHttpsCallable } from "react-firebase-hooks/functions";
import { userStatusTypes } from "../utils/constants";
import { useCollection } from "react-firebase-hooks/firestore";
import { usersQuery } from "../utils/queryHelpers";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isChanges, setIsChanged] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { authed, setAuthed } = useAuthContext();
  const { setLoading } = useLoaderContext();
  // console.log({ authed });

  // get users function hook
  const [snapshot, loading, queryError] = useCollection(usersQuery(), {
    snapshotListenOptions: {
      includeMetadataChanges: true,
    },
  });

  const [
    sendResetPasswordEmail,
    sendResetPasswordEmailExecuting,
    sendResetPasswordEmailFunctionError,
  ] = useHttpsCallable(getFunctions(firebaseApp), "sendResetPasswordEmail");

  let { CREATED, SENT_MAIL, JOINED } = userStatusTypes;

  // extract user data from data snapshots
  let userData =
    snapshot?.docs
      ?.map((data) => {
        const d = { ...data.data(), id: data.id };
        return d;
      })
      .filter(
        (user) =>
          ["undefined", undefined, JOINED].includes(user.status) 
      )
      .filter((user) =>
        ["undefined", undefined, false].includes(user.deleted)
      ) || [];

  const onSubmit = async (e) => {
    e.preventDefault();

    try {
      // find if user email is valid and joined
      let user = userData.find((u) => u.email === email);

      // if joined, send password reset link
      if (user) {
        setLoading(true);
        let res = await sendResetPasswordEmail({ email });

        // console.log("reset password res :: ", res);
        if (!res["error"]) {
          setIsChanged(true);
        } else {
          setError("Failed to send password reset link");
        }
      } else {
        setError("Invalid Email");
      }
    } catch (error) {
      setError("Failed to send password reset link");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (authed) navigate("/dashboard/business");
  }, [authed, navigate]);

  // const onSubmit = async (e) => {
  //   e.preventDefault();
  //   if (
  //     email.toLowerCase().trim() !== "surjan@iconnectsolutions.com" &&
  //     email.toLowerCase().trim() !== "jorge.rodriguez@influentialbrands.com"
  //   ) {
  //     setError("Not authorized");
  //     return;
  //   }
  //   setLoading(true);
  //   try {
  //     const user = await signInWithEmailAndPassword(fAuth, email, password);
  //     setAuthed(true);
  //     console.log(user);
  //   } catch (e) {
  //     setError(e.toString());
  //     console.log({ e });
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  return (
    <>
      <Form
        className="form-signin w-50 m-auto  d-flex align-items-center justify-content-center flex-column"
        style={{
          minHeight: "calc(100vh - 50px)",
        }}
      >
        {isChanges ? (
          <h4 className="">Password reset link sent to email.</h4>
        ) : (
          <>
            <h5 className="mb-4 text-center w-100">
              Please enter you e-mail ID below to receive password reset link
            </h5>
            <Form.Group className="mb-3 w-100" controlId="formBasicEmail">
              {/* <Form.Label>Email address</Form.Label> */}
              <Form.Control
                type="email"
                placeholder="Enter email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Group>

            <p className="text-danger small">{error}</p>
            <Button
              className="w-100"
              variant="primary"
              type="submit"
              onClick={onSubmit}
              style={{
                backgroundColor:
                  "linear-gradient(270deg, rgb(255, 208, 115) 25%, rgb(213, 162, 62) 50%, rgb(179, 130, 36) 75%) !important;",
                border: 0, // Set border to 0 to remove default button border
              }}
            >
              Submit
            </Button>
            {/* <div className="link">Forgot Password ?</div> */}
            <p
              className="mt-3 link-opacity-100 pointer"
              onClick={() => navigate("/login")}
            >
              Login ?
            </p>
          </>
        )}
      </Form>
    </>
  );
};

export default ForgotPassword;
